import { del } from "@insite/client-framework/Services/ApiService";
import { ClearCartApiParameter } from "@insite/client-framework/Services/CartService";

const clearCartUrl = "/api/v2/carts";
export interface CENRejectOrderApiParameter extends ClearCartApiParameter {
    remark: string;
}

export function clearCart(parameter: CENRejectOrderApiParameter) {
    return del(`${clearCartUrl}/${parameter.cartId}/${parameter.remark}`);
}
